module.exports = __webpack_public_path__ + "070246eb25759d95e9e2fa16c7a186b6.png";